import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}leave-types/`;
const TEMPLATE_URL = `${process.env.VUE_APP_API_URL}all-leave-types`;
const POLICY_URL = `${process.env.VUE_APP_API_URL}leave/policy-settings`;

export default {
  getAllLeaveType(params = {}) {
    return axios.get(API_URL, { params, headers: buildHeaders() });
  },

  getTemplates(params = {}) {
    return axios.get(TEMPLATE_URL, { params, headers: buildHeaders() });
  },

  getAll(params = {}) {
    return axios.get(API_URL, { params, headers: buildHeaders() });
  },

  get(id) {
    return axios.get(`${API_URL}${id}`, { headers: buildHeaders() });
  },
  create(data) {
    return axios.post(API_URL, data, { headers: buildHeaders() });
  },
  update(id, data) {
    return axios.put(`${API_URL}${id}`, data, { headers: buildHeaders() });
  },
  delete(id) {
    return axios.delete(`${API_URL}${id}`, { headers: buildHeaders() });
  },
  bulkDelete(ids) {
    return axios.post(
      `${API_URL}bulk-delete`,
      { ids },
      { headers: buildHeaders() }
    );
  },
  toggle(id, is_enabled) {
    return axios.put(
      `${API_URL}${id}/toggle`,
      { is_enabled },
      { headers: buildHeaders() }
    );
  },

  getPolicySettings() {
    return axios.get(POLICY_URL, { headers: buildHeaders() });
  },

  updatePolicySettings(payload) {
    return axios.put(POLICY_URL, payload, { headers: buildHeaders() });
  },
};
